<template>
  <div
    class="metro-list text-body-2 pl-8"
    data-qa="metro_list"
  >
    <div
      v-for="(metro, metroIndex) in lpuAddress.lpu.lpumetro_set.all.slice(0, 3)"
      :key="metro.metro.name"
      class="d-flex align-center text-secondary--text"
      :class="{
        'mt-1': !!metroIndex,
      }"
    >
      <span
        class="d-inline-block rounded-circle pa-1 mr-2"
        :style="{ 'background-color': metro.metro.color || '' }"
      />
      <span data-qa="metro_name">{{ transDynamic(metro.metro, `name,${language},${needTranslate}`) }}</span>

      <template v-if="metro.walk_time !== null">
        <template v-if="metro.walk_time < 60">
          <span class="ui-icon-pedestrian ui-icon-fz-smaller ml-2 mr-1" />
          <span data-qa="metro_distance">1 {{ t('мин', options) }}</span>
        </template>
        <template v-else>
          <span class="ui-icon-pedestrian ui-icon-fz-smaller ml-2 mr-1" />
          <span data-qa="metro_distance">{{ Math.floor(metro.walk_time / 60) }} {{ t('мин', options) }}</span>
        </template>
      </template>
    </div>
  </div>
</template>

<script setup lang="ts">
import I18NextVue from 'i18next'
import type { LpuAddressList } from 'www/vue_components/common/DoctorPageLpuList/types'
import transDynamic from 'djanjucks/filters/transDynamic'

defineProps<{
  lpuAddress: LpuAddressList[number]
}>()

const { t, language } = I18NextVue
const options = { ns: language }

const needTranslate = true
</script>
